import { useRef } from "react";
import compressImage from "../../../../utils/CompressImage";

// camera of the vehicle photos (tampak depan / kiri / kanan / belakang): a native <input type="file" capture>
// so on mobile it opens the device's own camera / gallery picker, the same interaction as the "Take Photo" button
// used for a checklist row's photo (genElZirvuImage) - instead of the old in-browser webcam-stream dialog.
// The photos of a checklist row are taken with genElZirvuImage in the row popover instead (see CheckMenu).
const useEditorCamera = ({
  savePengecekanBase64Image
}) => {
  const cameraInputRef = useRef(null);
  // the field / type ("berangkat" | "kembali") the next picked photo is for
  const cameraTargetRef = useRef(null);

  // handle UI event section

  const handleOnClickCameraPreview = (field, type) => {
    cameraTargetRef.current = { field, type };
    if (cameraInputRef.current) {
      // reset so picking the same file twice in a row still fires onChange
      cameraInputRef.current.value = "";
      cameraInputRef.current.click();
    }
  };

  const handleCameraFileChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file || !cameraTargetRef.current) return;

    const { field, type } = cameraTargetRef.current;

    // a raw camera photo is several MB, the server only accepts 2048 KB per photo field: resize first
    let photo = file;
    try {
      photo = await compressImage(file);
    } catch (err) {
      console.log("COMPRESS PHOTO ERROR", err);
    }

    const reader = new FileReader();
    reader.onload = () => {
      savePengecekanBase64Image({ type, field, base64Image: reader.result });
    };
    reader.readAsDataURL(photo);
  };

  return {
    cameraInputRef,
    handleOnClickCameraPreview,
    handleCameraFileChange
  };
};

export default useEditorCamera;
